import { render, staticRenderFns } from "./OrderContactsTab.vue?vue&type=template&id=59cf6cb4&scoped=true"
import script from "./OrderContactsTab.vue?vue&type=script&lang=js"
export * from "./OrderContactsTab.vue?vue&type=script&lang=js"
import style0 from "./OrderContactsTab.vue?vue&type=style&index=0&id=59cf6cb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cf6cb4",
  null
  
)

export default component.exports